// Backend URL for the customer portal.
//
// Switch environments by moving the comment: exactly one BASE_URL line stays
// uncommented. Keep in sync with botriq-admin-fe/src/config/config.js.

const CONFIG = {
  BASE_URL: "https://admin.botriq.com:5000", // production
  // BASE_URL: "http://localhost:5000", // local
};

export default CONFIG;
